import { dew as _constantsDew } from "../constants";
import { dew as _resultsDew } from "../../../results";
import { dew as _AbstractParserWithWordBoundaryDew } from "../../../common/parsers/AbstractParserWithWordBoundary";
import { dew as _timeunitsDew } from "../../../utils/timeunits";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const constants_1 = _constantsDew();
  const results_1 = _resultsDew();
  const AbstractParserWithWordBoundary_1 = _AbstractParserWithWordBoundaryDew();
  const timeunits_1 = _timeunitsDew();
  const PATTERN = new RegExp(`(deze|vorige|afgelopen|komende|over|\\+|-)\\s*(${constants_1.TIME_UNITS_PATTERN})(?=\\W|$)`, "i");
  class NLTimeUnitCasualRelativeFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
    innerPattern() {
      return PATTERN;
    }
    innerExtract(context, match) {
      const prefix = match[1].toLowerCase();
      let timeUnits = constants_1.parseTimeUnits(match[2]);
      switch (prefix) {
        case "vorige":
        case "afgelopen":
        case "-":
          timeUnits = timeunits_1.reverseTimeUnits(timeUnits);
          break;
      }
      return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }
  }
  exports.default = NLTimeUnitCasualRelativeFormatParser;
  //# sourceMappingURL=NLTimeUnitCasualRelativeFormatParser.js.map
  return exports;
}